export const CARD_MOCK = {
  EMPTY: {
    name: null,
    brand: null,
    masked_number: null,
    is_available_for_purchase: null,
    had_valid_loan: false,
  },
  IS_AVAILABLE: {
    name: 'Lorem Ipsum',
    brand: 'mastercard',
    masked_number: '000000XXXXXX2240',
    is_available_for_purchase: true,
    had_valid_loan: true,
  },
  IS_NOT_AVAILABLE: {
    name: 'Lorem Ipsum',
    brand: 'visa',
    masked_number: '000000XXXXXX2241',
    is_available_for_purchase: false,
    had_valid_loan: false,
  },
  AMERICAN_EXPRESS: {
    name: 'Lorem Ipsum',
    brand: 'american_express',
    masked_number: '000000XXXXX2242',
    is_available_for_purchase: true,
    had_valid_loan: false,
  },
};
